import api from './api';

export interface PoolMemberPayment {
  id: string;
  poolMemberId: string;
  transferId: string | null;
  amount: number;
  paymentDate: string;
  paymentMethod: string;
  notes?: string;
  createdAt: string;
  poolMember?: { id: string; fullName: string; phone: string };
  transfer?: { id: string; transferCode: string; transferDate: string; pickupLocation: string; dropoffLocation: string } | null;
  recordedBy?: { id: string; fullName: string };
}

export interface PoolMemberPaymentSummary {
  poolMemberId: string;
  poolMemberName: string;
  phone: string;
  transferCount: number;
  totalAmount: number;
  totalPaid: number;
  totalPending: number;
}

export interface CreatePoolMemberPaymentDto {
  poolMemberId: string;
  transferId?: string;
  amount: number;
  paymentDate: string;
  paymentMethod?: string;
  notes?: string;
}

export const poolMemberPaymentsService = {
  getAll: async (filters?: { poolMemberId?: string; startDate?: string; endDate?: string }): Promise<PoolMemberPayment[]> => {
    const params = new URLSearchParams();
    if (filters?.poolMemberId) params.append('poolMemberId', filters.poolMemberId);
    if (filters?.startDate) params.append('startDate', filters.startDate);
    if (filters?.endDate) params.append('endDate', filters.endDate);
    const response = await api.get(`/pool-member-payments?${params}`);
    return response.data;
  },

  getSummary: async (filters?: { poolMemberId?: string; startDate?: string; endDate?: string }): Promise<PoolMemberPaymentSummary[]> => {
    const params = new URLSearchParams();
    if (filters?.poolMemberId) params.append('poolMemberId', filters.poolMemberId);
    if (filters?.startDate) params.append('startDate', filters.startDate);
    if (filters?.endDate) params.append('endDate', filters.endDate);
    const response = await api.get(`/pool-member-payments/summary?${params}`);
    return response.data;
  },

  getUnpaidTransfers: async (poolMemberId: string): Promise<any[]> => {
    const response = await api.get(`/pool-member-payments/unpaid-transfers/${poolMemberId}`);
    return response.data;
  },

  create: async (data: CreatePoolMemberPaymentDto): Promise<PoolMemberPayment> => {
    const response = await api.post('/pool-member-payments', data);
    return response.data;
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/pool-member-payments/${id}`);
  },
};
